enum LOAI_DON_THUOC {
  TAO_MOI = "TAO_MOI",
  DA_TAO = "DA_TAO",
}

export {LOAI_DON_THUOC};
